"use strict";

exports.__esModule = true;
exports.Validator = void 0;

var _detect = require("./rules/detect");

exports.detect = _detect.detect;

var _min = require("./rules/min");

exports.min = _min.min;

var _max = require("./rules/max");

exports.max = _max.max;

var _maxCount = require("./rules/maxCount");

exports.maxCount = _maxCount.maxCount;

var _maxLength = require("./rules/maxLength");

exports.maxLength = _maxLength.maxLength;

var _minCount = require("./rules/minCount");

exports.minCount = _minCount.minCount;

var _minLength = require("./rules/minLength");

exports.minLength = _minLength.minLength;

var _regexp = require("./rules/regexp");

exports.regexp = _regexp.regexp;

var _required = require("./rules/required");

exports.required = _required.required;

var _array = require("./rules/types/array");

exports.array = _array.array;

var _date = require("./rules/types/date");

exports.date = _date.date;

var _digits = require("./rules/types/digits");

exports.digits = _digits.digits;

var _email = require("./rules/types/email");

exports.email = _email.email;

var _number = require("./rules/types/number");

exports.number = _number.number;

var _url = require("./rules/types/url");

exports.url = _url.url;

var _util = require("./util");

exports.registerRule = _util.registerRule;
exports.registerTypeRule = _util.registerTypeRule;
exports.validate = _util.validate;

var _Validator = require("./lib/Validator");

exports.Validator = _Validator.Validator;
(0, _util.registerRule)(_required.required);
(0, _util.registerRule)(_min.min);
(0, _util.registerRule)(_max.max);
(0, _util.registerRule)(_maxLength.maxLength);
(0, _util.registerRule)(_minLength.minLength);
(0, _util.registerRule)(_regexp.regexp);
(0, _util.registerRule)(_maxCount.maxCount);
(0, _util.registerRule)(_minCount.minCount);
(0, _util.registerRule)(_detect.detect);
(0, _util.registerTypeRule)('array', _array.array);
(0, _util.registerTypeRule)('date', _date.date);
(0, _util.registerTypeRule)('digits', _digits.digits);
(0, _util.registerTypeRule)('email', _email.email);
(0, _util.registerTypeRule)('number', _number.number);
(0, _util.registerTypeRule)('url', _url.url);